import type { Metric } from '../types.tsx';
import messages from './messages.tsx';

export const WORK_TYPES_KEY = 'worktype';

export const WORK_TYPES: Metric = {
	key: WORK_TYPES_KEY,
	visible: true,
	name: messages.nameNonFinal,
	description: messages.descriptionNonFinal,
	tabLabels: [messages.chartNonFinal, messages.reviewAndAnalyzeNonFinal],
	warningMessage: messages.warningNonFinal,
	exceededMessage: messages.exceededNonFinal,
	risks: [messages.risk1NonFinal],
	mitigations: [],
	currentValueLabel: messages.currentValueLabelNonFinal,
	currentValueAriaLabel: messages.currentValueAriaLabelNonFinal,
	thresholdValueLabel: messages.thresholdValueLabelNonFinal,
	thresholdValueAriaLabel: messages.thresholdValueAriaLabelNonFinal,
	recommendationUrl: '',
	recommendationUrlText: messages.recommendationUrlTextNonFinal,
	graphHeader: messages.graphHeaderNonFinal,
};
